(function () {
    'use strict';

    angular.module('app.invoices', [
        // Angular modules
        'ngRoute'

        // Custom modules

        // 3rd Party Modules

    ]);

})();